<template>
    <div>
        <div id="zmmtg-root"></div>
    </div>
</template>

<script>
    import profile from '~api/profile';
    import { mapGetters } from 'vuex';
    import VueTypes from 'vue-types';

    export default {
        props: {
            session: VueTypes.object.def({}),
            leaveUrl: VueTypes.string.def('')
        },
        data() {
            return {
                apiKey: process.env.VUE_APP_ZOOM_API_KEY,
                ZoomMtg: null
            };
        },
        computed: {
            ...mapGetters('auth', ['user'])
        },
        methods: {
            initZoom() {
                this.ZoomMtg = window.ZoomMtg;
                this.ZoomMtg.setZoomJSLib(
                    'https://source.zoom.us/2.14.0/lib',
                    '/av'
                );
                this.ZoomMtg.preLoadWasm();
                this.ZoomMtg.prepareWebSDK();
                // loads language files, also passes any error messages to the ui
                this.ZoomMtg.i18n.load('en-US');
                this.ZoomMtg.i18n.reload('en-US');

                this.getSignature();
            },
            async getSignature() {
                const resp = await profile.getZoomSignature(
                    this.session.awsData?.id
                );
                if (resp.ok) this.startMeeting(resp.data);
            },
            startMeeting(signature) {
                this.ZoomMtg.init({
                    leaveUrl: this.leaveUrl,
                    isSupportAV: true,
                    success: success => {
                        document.getElementById('zmmtg-root').style.display =
                            'block';
                        this.ZoomMtg.join({
                            meetingNumber: this.session.awsData?.id,
                            userName: this.user.fullName,
                            sdkKey: this.apiKey,
                            userEmail: this.user.email,
                            signature: signature.token,
                            passWord: this.session.awsData?.password,
                            success: success => {
                                console.log(success, 'success');
                            },
                            error: error => {
                                console.log(error, 'err');
                            }
                        });
                    },
                    error: error => {
                        console.log(error);
                    }
                });
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
    @import 'https://source.zoom.us/2.14.0/css/bootstrap.css';
    @import '../../../../assets/style/_variables.styl'
    main
        width: 70%;
        margin: auto;
        text-align: center;

    main button
        margin-top: 20px;
        background-color: $theme.primary
        color: #ffffff;
        text-decoration: none;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 40px;
        padding-right: 40px;
        display: inline-block;
        border-radius: 10px;
        cursor: pointer;
        border: none;
        outline: none;

    main button:hover
        background-color: rgba($theme.primary, 0.8)


    .video-option-menu__button
    .audio-option-menu__button
    .more-button__button
        height: 100%
        cursor: pointer
        float: left
        background-color: transparent
        width: 20px
        border: none
        border-radius: 0

    .audio-option-menu__pop-menu
    .video-option-menu__pop-menu
        text-align: left;
        background: rgba(17, 17, 17, 0.8);
        left: 50%;
        left: 114px;
        transform: translateX(-50%);
        bottom: 54px;

    .audio-option-menu__pop-menu > li > a
    .video-option-menu__pop-menu > li > a
        color: #999;
        padding: 5px 20px 5px 39px;
        position: relative;
        font-size: 12px;
</style>
